import React from 'react';
import { TTintColor } from '../types/tint-color.type';
import { robotint } from '../components/robotint';
import { dispatchTintColorUpdatedCustomEvent } from '../helpers/dispatch-tint-color-updated-custom-event.helper';

type TProps = {
  setIsTintServiceAvailable: (isAvailable: boolean) => void;
  isTintServiceAvailable: boolean;
  setSelectedTintColor: (selectedColor: TTintColor) => void;
  deleteColorFromSelected: () => void;
};

export const useTintColor = ({
  setSelectedTintColor,
  setIsTintServiceAvailable,
  isTintServiceAvailable,
  deleteColorFromSelected,
}: TProps) => {
  const handleSelectColor = (color: Required<TTintColor>) => {
    setSelectedTintColor(color);
    dispatchTintColorUpdatedCustomEvent(color);
    robotint.closeModal();
  };

  const openChooseColorModal = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (!isTintServiceAvailable) {
      setIsTintServiceAvailable(true);
    }
    robotint.openModal(event.currentTarget);
  };

  const handleDeleteColor = () => {
    deleteColorFromSelected();
    dispatchTintColorUpdatedCustomEvent(null);
  };

  return {
    handleSelectColor,
    openChooseColorModal,
    handleDeleteColor,
  };
};
